import cn from 'classnames';
import React, { PropsWithChildren } from 'react';

type Props = PropsWithChildren<{
  className?: string;
}>;

export const ContentArea = React.forwardRef<HTMLDivElement, Props>(
  (props, ref) => {
    const { className, children } = props;
    return (
      <div ref={ref} className={cn('content-area', className)}>
        {children}
      </div>
    );
  }
);

export const ContentContainer = React.forwardRef<HTMLDivElement, Props>(
  (props, ref) => {
    const { className, children } = props;
    return (
      <div ref={ref} className={cn('content-container', className)}>
        {children}
      </div>
    );
  }
);

export const MainContainer = React.forwardRef<HTMLDivElement, Props>(
  (props, ref) => {
    const { className, children } = props;
    return (
      <div ref={ref} role='main' className={cn('main-container', className)}>
        {children}
      </div>
    );
  }
);
